import { render, staticRenderFns } from "./PaymentTotemList.vue?vue&type=template&id=10129a08&scoped=true"
import script from "./PaymentTotemList.vue?vue&type=script&lang=js"
export * from "./PaymentTotemList.vue?vue&type=script&lang=js"
import style0 from "./PaymentTotemList.vue?vue&type=style&index=0&id=10129a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10129a08",
  null
  
)

export default component.exports